import React, {useEffect, useRef, useState, useLayoutEffect} from 'react'
import ModalDialog from '../modal-dialog'
import {useDispatch, useSelector} from 'react-redux'
import LocationPin from '../svg/LocationPin'
import LocationPinSingle from '../svg/LocationPinSingle'
import LocationPinPoint from '../svg/LocationPinPoint'
import DestinationPin from '../svg/DestinationPin'
import Icon from '../icon'
import { RemovecloseF, MappointF } from '../../icon-library'
import {Alert, Type} from "mesh-component-library"
import {generatePath} from './../../utilities/RedirectUtils'
import {
  disabledVehicleIcon,
  selectedTowDestinationIcon,
  selectedTowDestinationIconPepBoys,
  towDestinationOptionIcon,
  towDestinationOptionIconPepBoys
} from '../../app-consts/mapConstants'

import {
  clearCurrentLocation,
  clearDestination,
  clearDisablementAddress,
  clearNearByDestinations,
  clearTowToCustomDestinationList,
  removeDestinationAddress,
  requestGoogleNearbySearch,
  updateDestinationWithPredictionAddress,
  addGooglePlaceIdToDestination,
  requestAdditionalNearByDestinationsForDropdown,
  updateRescueDetails, refreshReducersToInitial,
  updateDestinationAddress,
  updateCommentRequest,
  updateScheduledServiceDateTime,
  setReadyToSubmitRescue,
  updateTowDistance,
  updateDestination,
  fetchPredictiveETA} from '../../action'
import Spinner from "../spinner"
import {useHistory} from 'react-router-dom'
import {
  ABG_NO_DESTINATION_NOTE_FOR_RA,
  ABG_REPLACEMENT_CAR_COMMENT,
  ABG_TRANSPORTATION_COMMENT,
  CANADA,
  TOW,
  TOW_SERVICE_ID,
  TOW_TO_LOCATION_TYPE_124,
  V15,
  WRD,
} from "../../app-consts/appConstants";
import {datadogRum} from '@datadog/browser-rum'
import SlideArrow from '../svg/SlideArrow'
import {useLocale} from "../../contexts/LocaleContext";
import {TRANSLATION_CONSTANTS} from "../../app-consts/translations";
import RightDirectArrow from '../svg/RightDirectArrow'
import titleCase from '../../utils/titleCase'
import {
  callToGetTimeZone,
  saveRescueDetails
} from '../../api/api'
import {
  getSchedulingEnabled,
  getHomeOperatorAddress,
  getServiceRequestPayload,
  getTowToLocationType,
  getOnlyOemVehiclesSupported,
  getTowToEnabled,
  getCustomDestinationEnabled,
  getTowToLocationSearch,
  getSupportedRegions,
  getPassThruEnabled,
  getDisableGoogleNearbyRecommendationsFlag
} from '../../selector'
import { isEmpty } from 'lodash'
import { formatCurrentTimeToScheduledServiceDateTime, formatMinutesToTimeRange } from '../../utils/timeUtil'
import { isScheduleService } from '../../utils/serviceRequestPayloadUtils'
import { DropdownListMember } from './ListMember';
import { ToggleView } from '../../screens/DropoffLocationSelection/components/ToggleView'
import { StyledToggleViewContainer } from './LocationViewToggle.styles'
import { getDisplayLocationViewToggle } from '../../screens/LocationRouter/selectors'
import { isABGPartner } from '../../utils'
import { getOmniStreamlinedFlag } from '../../features/FeatureFlags'
import { NoDestinationsFoundModal } from './Modals/NoDestinationsFound'
import { getCorrectAddress } from '../../utils/formatAddress'
import { mapDestinationForUpdateLocation } from '../../utilities/abg-util/destinationLocationMapper'
import { geocodeAddress } from '../../utils/mapsLocationHelper'

const google = window.google;

let destinationMarkers = []

const GoogleMap = (props) => {
  const {
    mapOptions,
    openInvalidAddressModal,
  } = props
  const history = useHistory();
  const dispatch = useDispatch();
  const nearByDestinationAutoCompleteService = new google.maps.places.AutocompleteService()

  const currentLocation            = useSelector(state => state.currentLocation)
  const serviceRequestPayload      = useSelector(getServiceRequestPayload);
  const nearByDestinations         = useSelector(state => state.nearByDestinations)
  const selectedDestinationDetails = useSelector(state => state.destination)
  const serviceInfo                = useSelector(state => state.serviceInfo)
  const rescueDetailsSent          = useSelector(state => state.generalInfo.rescueDetailsSent || false)
  const partnerDetails             = useSelector(state => state.partnerDetails.partnerDetails)
  const customDestinationList      = useSelector(state => state.generalInfo.towToCustomDestinationList)
  const displayHeader              = useSelector(state => getDisplayLocationViewToggle(state))
  const predictiveETA              = useSelector((state) => state.predictiveETA.data) || {};
  const schedulingEnabled          = useSelector(getSchedulingEnabled);
  const homeOperatorAddress        = useSelector(getHomeOperatorAddress);
  const isDropdownListOpenByDefault = !displayHeader;
  const omniStreamlined = useSelector(getOmniStreamlinedFlag);
  const {displayCode, appId, phone, partnerCode} = partnerDetails;
  const towToEnabled               = useSelector (getTowToEnabled);
  const towToLocationSearch        = useSelector (getTowToLocationSearch);
  const supportedRegions           = useSelector (getSupportedRegions);
  const customDestinationEnabled   = useSelector (getCustomDestinationEnabled);
  const passThruEnabled            = useSelector (getPassThruEnabled);
  const towToLocationType          = useSelector (getTowToLocationType);
  const onlyOemVehiclesSupported   = useSelector (getOnlyOemVehiclesSupported);
  const isHomeAddressDestination   = !!selectedDestinationDetails?.isHomeAddress;
  const disableGoogleNearbyRecommendationsFlag = useSelector(getDisableGoogleNearbyRecommendationsFlag);

  const [showSpinner, setShowSpinner] = useState(false)
  const [destinationName, setDestinationName] = useState(selectedDestinationDetails.formatted_address || '')
  const [displayNearByDestinationsDropdown, setDisplayNearByDestinationsDropdown] = useState(isDropdownListOpenByDefault)
  const [displayNoDestinationsFound, setDisplayNoDestinationsFound] = useState(false)
  const [currentLocationAddress, setCurrentLocationAddress] = useState(currentLocation.formatted_address)
  const [currentLocationMarker, setCurrentLocationMarker] = useState(null)
  const [destinationPredictions, setDestinationPredictions] = useState([])
  const [displayDestinationPredictions, setDisplayDestinationPredictions] = useState(false)
  const [customTowToDestinationPredictions, setCustomTowToDestinationPredictions] = useState(customDestinationList)
  const [displayCustomTowToDestinationPredictions, setDisplayCustomTowToDestinationPredictions] = useState(false)
  const [destinationMarkerFromSelectedPrediction, setDestinationMarkerFromSelectedPrediction] = useState(false)
  const [destinationInputFocus, setDestinationInputFocus] = useState(0)
  const [noTowDestinationFound, setNoTowDestinationFound] = useState(false)
  const [noTowCentersFoundText, setNoTowCentersFoundText] = useState("")
  const [map, setMap] = useState(null)
  const [propsArrowIcon, setPropsArrowIcon] = useState({})
  const getTranslatedText = useLocale();
  const [displayCustomABGNoDestinationMessage, setDisplayCustomABGNoDestinationMessage] = useState(false)

  let nearByDestinationIcon = towDestinationOptionIcon
  let selectedDestinationIcon = selectedTowDestinationIcon
  if(displayCode === 'PEP'){
    nearByDestinationIcon = towDestinationOptionIconPepBoys
    selectedDestinationIcon = selectedTowDestinationIconPepBoys
  }

  const destinationInputRef = useRef()
  //towToEnabled = true, customDestinationEnabled = false, and towToLocationType = 124 for both Ferrari and DriveSure partners.
  //To distinguish a DriveSure partner, checking that onlyOemVehiclesSupported = false.
  const isDriveSure = towToEnabled && !customDestinationEnabled && towToLocationType === TOW_TO_LOCATION_TYPE_124 && !onlyOemVehiclesSupported;
  const showClearIcon = destinationName && !isABGPartner(partnerCode) && !(isDriveSure && nearByDestinations?.error && isHomeAddressDestination);

  useEffect(() => {
    if (isABGPartner(partnerCode) && serviceInfo.service === 'tow' && selectedDestinationDetails.addressDetails) {
      dispatch(updateDestinationAddress(selectedDestinationDetails.addressDetails));
    }
  }, [selectedDestinationDetails.addressDetails]);

  useEffect(() => {
    let map = new google.maps.Map(mapRef.current, mapOptions)

    google.maps.event.addListenerOnce(map, 'idle', () => {
      setMap(map);
    });

    if(omniStreamlined && !rescueDetailsSent && serviceInfo.service === 'tow') {
      saveRescueDetails(serviceRequestPayload, partnerCode, '', history, (()=> dispatch(refreshReducersToInitial())))
      dispatch(updateRescueDetails(true))
    }
  }, [])

  useLayoutEffect(() => {
    if(map){
      resetMapBoundaries()
    }
  }, [map, currentLocation, selectedDestinationDetails, nearByDestinations])

  useEffect(() => {
    if(!map){
      return
    }

    if(currentLocation.formatted_address){
      setCurrentLocationAddress(currentLocation.formatted_address)
      if(currentLocationMarker){
        currentLocationMarker.setMap(null)
      }
      setCurrentLocationMarker(createMarker(disabledVehicleIcon, currentLocation.geometry.location));

      if(serviceInfo.id === TOW_SERVICE_ID && !nearByDestinations?.destinations?.length) {
        setShowSpinner(true);
        searchForNearByDestinations(currentLocation.geometry?.location);
      }
    }
  }, [map, currentLocation])

  // This use effect draws the markers to the map
  // AND handles logic for ABG
  useEffect(() => {
    if(!map){
      return
    }

    // If nearbyDestinations has an error and no destination has been selected
    if(nearByDestinations?.error && !Object.keys(selectedDestinationDetails).length) {
      if (disableGoogleNearbyRecommendationsFlag) {
        setDisplayNoDestinationsFound(false);
      } else if (isABGPartner(partnerCode)) {
        // ABG scheduled time logic for RA's
        const convertTimeToDisablementTimezone = async () => {
          let currentTime = new Date().getTime().toString();
          let result = {};
          try {
            result = await callToGetTimeZone(
              currentLocation.latitude,
              currentLocation.longitude,
              currentTime.toString().slice(0, 10)
            );
          } catch {
            datadogRum.addAction("Failed to get time zone information for missing destination");
          }

          let scheduledServiceDateTime = formatCurrentTimeToScheduledServiceDateTime(result?.data?.timeZoneId);
          dispatch(updateScheduledServiceDateTime(scheduledServiceDateTime));
        };

        setDisplayCustomABGNoDestinationMessage(true);
        const destinationNotFoundObj = {
          addressLine1: "",
          city: "",
          country: "",
          latitude: null,
          longitude: null,
          state: "",
          zipCode: "",
          addressLine2: "",
          bizName: ""
        };
        dispatch(updateDestinationAddress(destinationNotFoundObj));
        dispatch(updateCommentRequest(ABG_NO_DESTINATION_NOTE_FOR_RA))
        dispatch(setReadyToSubmitRescue(true))

        let isABGReplacementOrTransportationEnabled = serviceRequestPayload?.commentRequest?.comment?.includes(ABG_REPLACEMENT_CAR_COMMENT) ||
          serviceRequestPayload?.commentRequest?.comment?.includes(ABG_TRANSPORTATION_COMMENT);
        if (isABGReplacementOrTransportationEnabled) {
          dispatch(updateScheduledServiceDateTime({}));
        }
        if (!isABGReplacementOrTransportationEnabled) {
          convertTimeToDisablementTimezone();
        }
      } else {
        setDisplayNoDestinationsFound(true);
      }
    } else {
      let newMarkerArray = []
      if (nearByDestinations?.destinations?.length) {
        nearByDestinations.destinations.forEach((destination) => {
          let marker = createNearByDestinationMarker(nearByDestinationIcon, destination);
          newMarkerArray.push(marker)
        })
        destinationMarkers = newMarkerArray
      }
    }

    if (nearByDestinations?.error || nearByDestinations?.destinations?.length) {
      setShowSpinner(false)
    }
  },[map, nearByDestinations])

  useEffect(() => {
    if(!map){
      return
    }

    if(selectedDestinationDetails?.error){
      openInvalidAddressModal()
      setShowSpinner(false)
    }

    if(destinationMarkerFromSelectedPrediction){
      destinationMarkerFromSelectedPrediction.setMap(null)
    }

    if(!selectedDestinationDetails.formatted_address){
      setDestinationName('')
      destinationMarkers.forEach((marker) => {
        marker.setMap(map)
        marker.setIcon(nearByDestinationIcon)
      })
    }

    if(selectedDestinationDetails.formatted_address) {
      handleUpdatedSelectedDestination(selectedDestinationDetails)
    }

  }, [map, selectedDestinationDetails])

  useEffect(() => {
    if (destinationInputFocus) {
      destinationInputRef?.current.focus();
    }
  }, [destinationInputFocus])

  useEffect(() => {
    let iconValues = {
      className: 'active deleteDropoff arrowDown',
      color: "focus",
      direction:'up',
      role: 'down-arrow-svg'
    }

    if(!displayNearByDestinationsDropdown) {
      iconValues.direction = 'down'
      iconValues.rotate = 'rotate'
    }

    setPropsArrowIcon(iconValues)

  }, [displayNearByDestinationsDropdown])

  useEffect( () => {
    const getEta = async () => {
      try {
        // No predictive ETA for WTD per Brinder: https://teams.microsoft.com/l/message/19:meeting_N2VhMmY5MWYtOWY4Zi00NjViLTgwODQtOTVlMGU1NGEzZWIy@thread.v2/1784928831199?context=%7B%22contextType%22%3A%22chat%22%7D
        if ((!isScheduleService(serviceRequestPayload) || (!schedulingEnabled && isScheduleService(serviceRequestPayload))) && partnerDetails.partnerCode !== WRD) {
          let predictiveEtaPayload = {
            currentLocation,
            isTow: serviceInfo.value === TOW,
            appId: partnerDetails.appId,
            partnerCode: partnerDetails.partnerCode,
            source: "GoogleMap",
          };
          if (!!omniStreamlined) {
            predictiveEtaPayload.callId = serviceRequestPayload?.sessionId;
          } else {
            predictiveEtaPayload.sessionId = serviceRequestPayload?.sessionId;
          }
          dispatch(fetchPredictiveETA(predictiveEtaPayload));
        }
      } catch (error) {
        datadogRum.addError(new Error(`Rescue Status View error in getPredictiveEta - error: ${error}`));
      }
    };
    getEta();
  }, [])

  const handleUpdatedSelectedDestination = (selectedDestinationDetails) => {
    const {formatted_address,name} = selectedDestinationDetails
    let displayName = formatted_address.includes(name) ? formatted_address : name + ", " + formatted_address
    if(showSpinner){
      setShowSpinner(false)
    }
    setDestinationName(displayName)
    setDisplayNearByDestinationsDropdown(false)
    setDisplayDestinationPredictions(false)

    updateSelectedDestinationIcon()
  }

  const resetMapBoundaries = () => {
    if (!currentLocation.geometry?.location) {
      return;
    }
    const bounds = new google.maps.LatLngBounds()

    if(currentLocation.geometry) {
      bounds.extend(currentLocation.geometry.location);
    }

    if(selectedDestinationDetails.geometry){
      bounds.extend(selectedDestinationDetails.geometry.location);
    }

    if(nearByDestinations?.destinations?.length){
      nearByDestinations.destinations.forEach((destination) => {
        bounds.extend(destination.geometry.location);
      })
    }

    map.fitBounds(bounds);

    if(!currentLocation.geometry && !selectedDestinationDetails.geometry && !nearByDestinations?.destinations?.length) {
      let lat = supportedRegions[0]===CANADA ? 56.1304 : 39.82835
      let lng = supportedRegions[0]===CANADA ? -106.3468 : -98.5816684
      map.setCenter({lat, lng});
      map.setZoom(4);
    }
    else if(currentLocation.geometry && !selectedDestinationDetails.geometry && !nearByDestinations?.destinations?.length){
      map.setZoom(16);
    }
    else if(currentLocation.geometry && selectedDestinationDetails.geometry && !nearByDestinations?.destinations?.length){
      map.setZoom(map.getZoom() - 1.5);
    }
  }

  const updateSelectedDestinationIcon = () => {
    if(destinationMarkers.length){
      destinationMarkers.forEach((marker) =>{
        if(marker.placeId === selectedDestinationDetails.place_id){
          marker.setIcon(selectedDestinationIcon)
        } else {
          if(selectedDestinationDetails.hasBeenConfirmed){
            marker.setMap(null)
          } else {
            marker.setIcon(nearByDestinationIcon)
          }
        }
      })
    }

    let marker = createNearByDestinationMarker(selectedDestinationIcon, selectedDestinationDetails);
    setDestinationMarkerFromSelectedPrediction(marker)
  }

  const createMarker = (icon, latLng, label, placeId) => {
    let marker = new google.maps.Marker({
      position: latLng,
      map,
      icon: icon,
    });
    marker.placeId = placeId
    return marker
  }

  const createNearByDestinationMarker = (icon, destination) => {
    const marker = createMarker(icon, destination.geometry.location, destination.name, destination.place_id)
    marker.addListener("click", () => {
      if(towToEnabled){
        let value = destination.name + ', ' + titleCase(destination.vicinity);
        selectCustomTowToLocationFromPredictions(value)
      } else {
        selectNewDestinationFromPredictions(destination.place_id)
      }
    })
    return marker
  }

  const searchForNearByDestinations = (location) => {
    let service = new google.maps.places.PlacesService(map);
    const searchParams = {
      location,
      placeService: service,
      displayCode,
      appId,
      history
    }
    dispatch(requestGoogleNearbySearch(searchParams));
  }

  const displayNearByDestinationList = () => {
    if(!displayDestinationPredictions && !nearByDestinations.error){
      setDisplayNearByDestinationsDropdown(true)
    }
    if (towToEnabled && customDestinationEnabled && passThruEnabled) {
      setDisplayCustomTowToDestinationPredictions(false)
    }
  }

  const deleteDestinationInput = () => {
    setDisplayDestinationPredictions(false)
    setDisplayCustomTowToDestinationPredictions(false)
    setDestinationName('')
    destinationMarkers.forEach((marker)=>marker.setMap(map))
    dispatch(clearDestination())
    dispatch(removeDestinationAddress())
    !nearByDestinations.error && setDisplayNearByDestinationsDropdown(isDropdownListOpenByDefault);
  }

  const resetCurrentLocation = () => {
    destinationMarkers.forEach((marker)=>marker.setMap(null))
    destinationMarkers = []
    dispatch(clearDestination());
    dispatch(removeDestinationAddress())
    dispatch(clearNearByDestinations());
    dispatch(clearTowToCustomDestinationList())
    dispatch(clearCurrentLocation());
    dispatch(clearDisablementAddress())
    dispatch(setReadyToSubmitRescue(false))
    dispatch(updateTowDistance({
          scalar: 0,
          unitMeasure: "mi",
        }))
    history.push(generatePath('disablementlocation'));
  }

  const selectNewDestinationFromPredictions = (placeId) => {
    setDisplayDestinationPredictions(false)
    let service = new google.maps.places.PlacesService(map);
    const data = {service, placeId, origin: currentLocation.geometry.location}

    setDestinationName('')
    destinationMarkers.forEach((marker)=>marker.setMap(null))
    setShowSpinner(true)
    dispatch(updateDestinationWithPredictionAddress(data))
  }

  const selectCustomTowToLocationFromPredictions = (query) => {
    setShowSpinner(true)
    setDisplayCustomTowToDestinationPredictions(false)
    let service = new google.maps.places.PlacesService(map);
    dispatch(addGooglePlaceIdToDestination({
      query,
      service,
      origin: currentLocation.geometry.location
    }))
  }

  const getDestinationPredictions = ({target: {value}}) => {
    try{
      setDisplayNearByDestinationsDropdown(false)
      setDestinationName(value)

      let bounds = new google.maps.LatLngBounds(map.getBounds().getSouthWest(), map.getBounds().getNorthEast())
      const predictionsRequest = {
        input: value,
        componentRestrictions: {country: 'us'},
        origin: currentLocation.geometry.location,
        bounds
      }

      const displaySuggestions = (predictions, status) => {
        if (value.length > 2 && status === google.maps.places.PlacesServiceStatus.OK) {
          predictions.sort((a, b) => (a.distance_meters > b.distance_meters) ? 1 : -1)
          setDestinationPredictions(predictions)
          setDisplayDestinationPredictions(true)
        } else {
          setDisplayDestinationPredictions(false)
        }
      };

      nearByDestinationAutoCompleteService.getPlacePredictions(predictionsRequest, displaySuggestions);
    } catch(error){
      datadogRum.addError(new Error(`GoogleMap error in getDestinationPredictions - error: ${error}, address: ${value}`));
    }
  }

  const dropDownOverlayClick = () => {
    setDisplayNearByDestinationsDropdown(false)
  }

  const mapRef = useRef()
  const createMapTemplate = () => {
    return(
      <div className="l-grid">
        <div className="l-grid__col l-grid__col--12">
          <div className='l-grid fullheight'>
            <div
              className="l-grid__col l-grid__col--12"
              id={'service-map'}
              ref={mapRef}>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const renderCurrentAddressFormField = () => {
    return (
      <div className="dropoffGroup">
        <input name="disablement-address"
               autoComplete="off"
               id="formField"
               type="text"
               className={'placename'}
               placeholder={getTranslatedText(TRANSLATION_CONSTANTS.ENTER_CURRENT_LOCATION)}
               aria-label={'Current Location'}
               value={currentLocationAddress}
               disabled/>
        {currentLocationAddress &&
          <Icon role="link"
                ariaLabel="Delete Disablement Address"
                tabIndex="0"
                icon={RemovecloseF}
                color="gray-darker"
                className={'active deletePlace'}
                onClick={resetCurrentLocation}
                onKeyDown={resetCurrentLocation}
          size={1}
        />
        }
      </div>
    )
  }

  const closeNoLocationModalHandler = () => {
    setDisplayNoDestinationsFound(false)
    setDestinationInputFocus(destinationInputFocus + 1)
  }

  const displayAdditionalDestinations = () => {
    if(nearByDestinations?.error && !Object.keys(selectedDestinationDetails).length) {
      if (disableGoogleNearbyRecommendationsFlag) {
        setDisplayNoDestinationsFound(false)
      } else if(isABGPartner(partnerCode)) {
        setDisplayCustomABGNoDestinationMessage(true)
      } else {
        setDisplayNoDestinationsFound(true)
      }
    } else {
      setDisplayNearByDestinationsDropdown(!displayNearByDestinationsDropdown)
    }
  }

  const getTowText = () => {
    if (towToEnabled && !towToLocationSearch && !displayCustomABGNoDestinationMessage) {
      return getTranslatedText(TRANSLATION_CONSTANTS.SELECT_TOW_LOCATION);
    // ABG selects a location for the customer automatically, or defaults to an 'Authorized Maintenance Facility'
    } else if (displayCustomABGNoDestinationMessage) {
      return getTranslatedText(
        TRANSLATION_CONSTANTS.AUTHORIZED_MAINTENANCE_FACILITY
      );
    // V15 (VAS) has specific verbiage
    } else if (partnerCode === V15) {
      return getTranslatedText(TRANSLATION_CONSTANTS.ENTER_TOW_DESTINATION);
    } else {
      return getTranslatedText(
        TRANSLATION_CONSTANTS.SELECT_OR_ENTER_TOW_DESTINATION
      );
    }
  }

  const renderDestinationInputFormField = () => {
    return (
      <div className="dropoffGroup">
        <div onClick={displayNearByDestinationList}>
          <input autoComplete="off"
               id="destinationFormField"
               ref={destinationInputRef}
               type="text"
               className='dropname'
               aria-label='Search for new destination'
               placeholder={getTowText()}
               value={destinationName}
               onChange={getDestinationPredictions}
               disabled={isABGPartner(partnerCode) || towToEnabled && !customDestinationEnabled}/>
        </div>
        {
          nearByDestinations && !destinationName &&
          <SlideArrow {...propsArrowIcon} onClick={() => displayAdditionalDestinations()} />
        }
        {
          destinationName && !isABGPartner(partnerCode) &&
          <Icon role="link"
                ariaLabel="Delete Destination Address"
                tabIndex="0"
                icon={RemovecloseF}
                color="gray-darker"
                className={'active deleteDropoff'}
                onClick={deleteDestinationInput}
                onKeyDown={deleteDestinationInput}
                size={1}/>
        }
      </div>
    )
  }

  const renderTowToDestinationSearchableFormField = () => {
    return (
      <div className="dropoffGroup">
        <div onClick={displayNearByDestinationList}>
          <input autoComplete="off"
                 id="destinationFormField"
                 ref={destinationInputRef}
                 type="text"
                 className={'dropname'}
                 aria-label={'Search for new destination'}
                 placeholder={getTowText()}
                 value={destinationName}
                 onChange={onValueChanged}
                 disabled={isABGPartner(partnerCode) || isDriveSure}
                 />
        </div>
        {
          (nearByDestinations && !destinationName) &&
          (<SlideArrow {...propsArrowIcon} onClick={() => displayAdditionalDestinations()} />)
        }
        {
          showClearIcon &&
          <Icon role="link"
                ariaLabel="Delete Destination Address"
                tabIndex="0"
                icon={RemovecloseF}
                color="gray-darker"
                className={'active deleteDropoff'}
                onClick={deleteDestinationInput}
                onKeyDown={deleteDestinationInput}
                size={1}/>
        }
      </div>
    )
  }

  const closeNoTowLocationModalHandler = () => {
    setNoTowDestinationFound(false)
    setDestinationName("")
    setDisplayNearByDestinationsDropdown(true)
  }
  const onValueChanged = ({target: {value}}) => {
    if (value.length > 2) {
      setDisplayNearByDestinationsDropdown(false)

      const pattern = new RegExp(`${value}`, 'i')
      const suggestions = customDestinationList.filter((location) => location.searchableName.match(pattern))

      if (suggestions.length > 0) {
        setNoTowDestinationFound(false);
        setDisplayCustomTowToDestinationPredictions(true)
        setCustomTowToDestinationPredictions(suggestions)
      } else {
        setNoTowDestinationFound(true);
        setDisplayNearByDestinationsDropdown(false)
        setDisplayCustomTowToDestinationPredictions(true)
        setCustomTowToDestinationPredictions([])
        setNoTowCentersFoundText(getTranslatedText(TRANSLATION_CONSTANTS.NO_SUGGESTIONS));
      }
    } else {
      setDisplayNearByDestinationsDropdown(true)
      setDisplayCustomTowToDestinationPredictions(true)
      setCustomTowToDestinationPredictions([])
    }
    setDestinationName(value)
  }

  const renderCustomTowToPredictionsDropdownList = (towToDestinationPredictions) => {
    return (
      <div className={'softService c-currentOptions'}>
        <div className="c-currentPredictions">
          <div className="c-currentPredictions__itemcontain">
            {
              towToDestinationPredictions.map((towToPrediction, i) => {
                return (
                  <a tabIndex={0}
                     key={`dropdown-list-${towToPrediction.searchableName}`}
                     className="c-currentPredictions__item"
                     onClick={() => selectCustomTowToLocationFromPredictions(towToPrediction.searchableName)}>
                    <LocationPinPoint/>
                    <p className="u-text-truncate">{towToPrediction.searchableName}</p>
                  </a>
                )
              })
            }
          </div>
        </div>
      </div>
    )
  }


  const renderPredictionsDropdownList = (predictions, setNewLocation) => {
    return (
      <div className={`${serviceInfo.id !== TOW_SERVICE_ID ? 'softService' : ''} c-currentOptions`}>
        <div role="link"
             tabIndex={0}
             className="c-currentOptions__disablement">
          <DestinationPin/>
          <p>Select from these suggestions...</p>
        </div>
        <div className="c-currentPredictions">
          <div className="c-currentPredictions__itemcontain">
            {
              predictions.map((prediction, i) => {
                return (
                  <a tabIndex={0}
                     key={`dropdown-list-${prediction.place_id}`}
                     className="c-currentPredictions__item"
                     onClick={() => setNewLocation(prediction.place_id)}
                     onKeyDown={(e) => {
                       const active = document.activeElement;
                       if (e.keyCode === 13) {
                         setNewLocation(prediction)
                       } else if (e.keyCode === 38 &&
                         active.previousSibling) {
                         active.previousSibling.focus();
                       } else if (e.keyCode === 40 && active.nextSibling) {
                         active.nextSibling.focus();
                       }
                     }}>
                    <LocationPinPoint/>
                    <p className="u-text-truncate">{prediction.description}</p>
                  </a>
                )
              })
            }
          </div>
        </div>
      </div>
    )
  }

  const selectNewDestinationValue = (destination) => {
    if(isABGPartner(partnerCode) && !!customDestinationList?.length){
      dispatch(updateTowDistance({
        scalar: destination?.totalMiles ?? destination?.towInfo?.distanceFromCurrentLocation ?? -1,
        unitMeasure: destination?.towInfo?.unitsShorthand ?? "mi",
      }))
      const value = destination.name + ', ' + titleCase(destination.vicinity);

      const selectedDestination = getCorrectAddress({towToCustomDestinationList: customDestinationList, address : value})
      const destinationLocation = mapDestinationForUpdateLocation(selectedDestination, destination)
      dispatch(updateDestination(destinationLocation))
    }
    else if(towToEnabled) {
      let value = destination.name + ', ' + titleCase(destination.vicinity);
      selectCustomTowToLocationFromPredictions(value)
    } else{
      selectNewDestinationFromPredictions(destination.place_id)
    }
  }

  const handleSelectHomeAddressDestination = (homeAddressDisplay, homeAddressData) => {
    setDisplayNearByDestinationsDropdown(false);
    setShowSpinner(true);

    geocodeAddress(homeAddressDisplay, (placeResult) => {
        let service = new google.maps.places.PlacesService(map);
        const data = {
          service,
          placeId: placeResult.place_id,
          origin: currentLocation.geometry.location,
          isHomeAddress: true,
          homeAddressData: {
            ...homeAddressData,
            geometry: placeResult.geometry,
            formatted_address: placeResult.formatted_address
          }
        };

        setDestinationName('');
        destinationMarkers.forEach((marker) => marker.setMap(null));
        dispatch(updateDestinationWithPredictionAddress(data));
      },(status) => {
        setShowSpinner(false);
        datadogRum.addError("Unable to geocode Home address from retrieveBenefits response", {
          status,
          homeAddressDisplay,
        });
      }
    );
  }

  const getHomeAddressDisplayAndData = () => {
    const { line1, city, stateCode, zipCode, countryCode } = homeOperatorAddress;
    const cityStateZip = [city, [stateCode, zipCode].filter(Boolean).join(" ")].filter(Boolean).join(", ");
    const homeAddressDisplay = [line1, cityStateZip, countryCode].filter(Boolean).join(", ");

    const homeAddressData = {
      line1,
      city,
      stateCode,
      zipCode,
      countryCode,
    };

    return { homeAddressDisplay, homeAddressData };
  }

  const handleSelectHomeAddressFromNoDestinationsFoundModal = () => {
    const { homeAddressDisplay, homeAddressData } = getHomeAddressDisplayAndData();

    if (!homeAddressDisplay) {
      return;
    }

    closeNoLocationModalHandler();
    handleSelectHomeAddressDestination(homeAddressDisplay, homeAddressData);
  }

  const renderHomeAddressDestinationListMember = () => {
    const { homeAddressDisplay, homeAddressData } = getHomeAddressDisplayAndData();

    if (!homeAddressDisplay) {
      return null;
    }

    return (
      <a
        key="list-member-home-address"
        data-testid="near-by-destination-home-address"
        className="dropoffModal__promoted"
        onClick={() => handleSelectHomeAddressDestination(homeAddressDisplay, homeAddressData)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            e.currentTarget.click();
          }
        }}
        tabIndex={0}
      >
        <Icon icon={MappointF} color="gray-light" className="dropoffPin" size={1} />
        <div>
          <p className="title">{getTranslatedText(TRANSLATION_CONSTANTS.HOME_ADDRESS)}</p>
          <p className="address">{homeAddressDisplay}</p>
        </div>
      </a>
    );
  }

  const renderNearbyPreferredDestinationsDropdownList = () =>
    nearByDestinations?.destinations?.length ? (
      <>
        {renderHomeAddressDestinationListMember()}
        {nearByDestinations.destinations.map((destination, i) => (
          <DropdownListMember
            key={`list-member-${destination.name}`}
            index={i}
            onClick={selectNewDestinationValue}
            destination={destination}
          />
        ))}
      </>
    ) : null;

  const findNearestOpenLocation = () => {
    const nearestOpenDestination = nearByDestinations?.destinations?.[0] ?? null;
    if (nearByDestinations.destinations.length === 0 && nearByDestinations?.error) {
      if (!nearestOpenDestination) {
        setDisplayNearByDestinationsDropdown(false);
      }
    };

    if (nearByDestinations.destinations.length === 0) {
      return;
    };

    if (nearestOpenDestination) {
      dispatch(updateScheduledServiceDateTime({}));
      setDisplayNearByDestinationsDropdown(false);
      selectNewDestinationValue(nearestOpenDestination);
      dispatch(updateCommentRequest(""))
      dispatch(setReadyToSubmitRescue(true))
    }
  }

  const checkIfDisplayDropdownOrLocationFirst = () => {
    if (towToEnabled && isABGPartner(partnerCode)) {
      findNearestOpenLocation();
    } else {
      return renderDestinationDropdownList();
    }
  }

  const renderDestinationDropdownList = () => {
    if (!map) {
      // map is not defined or null, so return an empty container
      return <div></div>;
    }
    let service = new google.maps.places.PlacesService(map);
    return (
      <div className="dropoffModal">
        {renderNearbyPreferredDestinationsDropdownList()}
        {
          (nearByDestinations?.destinations?.length <
            nearByDestinations?.places?.length) && (
            <div className="see-more-main" onClick={() =>
              dispatch(
                requestAdditionalNearByDestinationsForDropdown({
                  service,
                  destinations: nearByDestinations?.destinations,
                })
              )
            }>
              <span className="see-more-text">
                <span>{getTranslatedText(TRANSLATION_CONSTANTS.SEE_MORE)}</span>
              </span>
              <span className="see-more-icon">
                <RightDirectArrow />
              </span>
            </div>
          )
        }
      </div>
    )
  }

  const renderInputFieldPins = () => {
    const pinColor = selectedDestinationDetails.formatted_address ? '#0033A0' : '#B9C6D3'
    const locationPinColor = currentLocation.formatted_address ? '#0033A0' : '#B9C6D3'
    return (
      serviceInfo.id === TOW_SERVICE_ID ?
        <LocationPin pinColor={pinColor} locationColor={locationPinColor}/>
        :
        <LocationPinSingle locationColor={locationPinColor}/>
    )
  }

  const getPredictiveETAAlertMessage = () => {
    const {petaFrom, petaTo} = formatMinutesToTimeRange(serviceInfo.value === TOW, predictiveETA);
    return getTranslatedText(TRANSLATION_CONSTANTS.PETA_ALERT).replace("{{petaFrom}}", petaFrom).replace("{{petaTo}}", petaTo);
  }

  return (
    <div className="c-google-map" id="location-map">
      {showSpinner && <Spinner/>}
      {createMapTemplate()}
      {
        displayNearByDestinationsDropdown &&
        <div role="figure"
             tabIndex={0}
             className="c-google-map--overlay"
             onClick={dropDownOverlayClick}
             onKeyDown={dropDownOverlayClick}/>
      }
      {
        displayNoDestinationsFound &&
        <NoDestinationsFoundModal
          closeModal={closeNoLocationModalHandler}
          selectHomeAddress={handleSelectHomeAddressFromNoDestinationsFoundModal}
          isDriveSurePartner={isDriveSure}
        />
      }
      {
        noTowDestinationFound &&
        <ModalDialog id="locationError"
                     title="No Tow Destination found"
                     promptType="error"
                     hideTrigger={true}
                     isActive={true}
                     onClose={closeNoTowLocationModalHandler}>
          <p>{noTowCentersFoundText}</p>
          <div className="l-grid">
              <div className="l-grid__col l-grid__col--12">
                <a className="c-btn c-btn--primary" onClick={closeNoTowLocationModalHandler}>
                  Try Again
                </a>
              </div>
            <div className="l-grid__col l-grid__col--12">
              <a className="c-btn c-btn--primary" href={`tel: ${phone}`}>
                {getTranslatedText(TRANSLATION_CONSTANTS.CALL_CUSTOMER_SERVICE)}
              </a>
            </div>
          </div>
        </ModalDialog>
      }

      <div className={'dropNameContain'}>
        <div className="dropNameContain--internal">
          {renderInputFieldPins()}
          <div>
            {renderCurrentAddressFormField()}
            {(() => {
              if (serviceInfo.id === TOW_SERVICE_ID){
                if(!towToEnabled || (customDestinationEnabled && !passThruEnabled)){
                  return renderDestinationInputFormField()
                } else{
                  return renderTowToDestinationSearchableFormField()
                }
              }
            })()}
          </div>
        </div>

        {displayDestinationPredictions && renderPredictionsDropdownList(destinationPredictions, selectNewDestinationFromPredictions)}
        {displayNearByDestinationsDropdown && checkIfDisplayDropdownOrLocationFirst()}
        {displayCustomTowToDestinationPredictions && renderCustomTowToPredictionsDropdownList(customTowToDestinationPredictions)}
        {displayHeader &&
          <StyledToggleViewContainer className='locationViewToggle'>
          <ToggleView />
          </StyledToggleViewContainer>
        }
      </div>
      {/* Only display this if new UI not in effect */}
      {!displayHeader && (!isScheduleService(serviceRequestPayload) || (!schedulingEnabled && isScheduleService(serviceRequestPayload))) && !isEmpty(predictiveETA) &&
        <Alert
          className={serviceInfo.value === TOW ? "petaAlert" : "petaAlert petaAlert--nonTow"}
          variant="information"
          size="sm"
        >
          <Type align="left" className="petaAlertText">
            {getPredictiveETAAlertMessage()}
          </Type>
        </Alert>
      }
    </div>
  )
}

export default GoogleMap
